<template>
  <div>
    <div class="text-center mb-5 px-3">
      <h1 class="mb-5">
        <strong></strong>
      </h1>
    </div>
    <div class="card" :class="$style.container">
      <!-- <div class="text-dark font-size-24 mb-3">
        <strong>{{ $t("authPage.singinToAccount") }}</strong>
      </div> -->
      <!-- <a :href="ssoToken"> Login with Microsoft</a> -->
      <a-button type="primary" icon="windows" :href="ssoToken" size="large">
        Login with Microsoft
      </a-button>
      <!-- <a-form class="mb-4" :form="form" @submit="login">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="[
              'email',
              {
                initialValue: 'admin@ict24h.net',
                rules: [
                  {
                    required: true,
                    message: this.$t('authPage.plzInputYourName'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Password"
            type="password"
            v-decorator="[
              'password',
              {
                initialValue: 'abc123456',
                rules: [
                  { required: true, message: 'Please input your Password!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center w-100"
        >
          <strong>Sign in</strong>
        </a-button>
      </a-form> -->
      <!-- <router-link
        to="/auth/forgot-password"
        class="kit__utils__link font-size-16"
      >
        Forgot Password?
      </router-link> -->
    </div>
    <!-- <div class="text-center pt-2 mb-auto">
      <span class="mr-2">Don't have an account?</span>
      <router-link to="/auth/register" class="kit__utils__link font-size-16">
        Sign up
      </router-link>
    </div> -->
  </div>
</template>
<script>
import { mapActions } from "vuex";

import Mutation from "./mutation";

const SP_URL = process.env.VUE_APP_SP_URL;
const MS_TOKEN = process.env.VUE_APP_MS_TOKEN_NAME;
const SSO_URL = process.env.VUE_APP_SSO_URL;
const callbackUrl = SP_URL
  ? SP_URL + "callback.html"
  : window.location.origin + "/callback.html";
const { VUE_APP_SP_HOST, VUE_APP_SP_SITE_URL } = process.env;
//  created() {
//     const urlRedirect = SSO_URL + "go?r=" + callbackUrl;
//     window.location.replace(urlRedirect);
//   },
export default {
  name: "Login",
  data: function () {
    return {
      form: this.$form.createForm(this),
      isGetUserLoading: false,
      ssoToken: SSO_URL + "go?r=" + callbackUrl,
    };
  },
  created() {
    const urlRedirect = `https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/login/?to=https://${VUE_APP_SP_HOST}/${VUE_APP_SP_SITE_URL}/admin/`;
    window.location.replace(urlRedirect);
  },
  methods: {
    ...mapActions({
      loginAuth: "auth/login",
    }),
    login(e) {
      this.isGetUserLoading = true;

      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start();

          const tranformData = {
            email: values.email,
            password: values.password,
          };

          this.$apollo
            .mutate({
              // Query
              mutation: Mutation.login,
              // Parameters
              variables: tranformData,
            })
            .then((data) => {
              // Result
              if (data.data.login && data.data.login.token) {
                this.loginAuth(data.data.login.token);
              }
              this.isGetUserLoading = false;
              this.$nprogress.done();
              this.$router.push("/");
              this.$notification.success({
                message: "Logged In",
                description: "You have successfully logged in!",
              });
            })
            .catch((error) => {
              // Error
              console.error("Up loi roi", error);
              this.isGetUserLoading = false;
              this.$nprogress.done();
              this.$notification.warning({
                message: "Không thể đăng nhập",
                // description: error.message,
              });
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" module>
@import "@/components/system/Auth/style.module.scss";
</style>
